"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toKebabCase = function (str) {
    if (str === void 0) { str = ""; }
    return str
        .replace(/[^a-z]/gi, "-")
        .replace(/\B([A-Z])/g, "-$1")
        .toLowerCase();
};
exports.default = toKebabCase;
